export const Types_Inventario = {
    ATUALIZAR_ETAPA: "ATUALIZAR_ETAPA",
    ATUALIZAR_ITEM_ATUAL: "ATUALIZAR_ITEM_ATUAL",
    ABRIR_INVENTARIO: "ABRIR_INVENTARIO",
    ATUALIZAR_ITEM_INCONSISTENCIA: "ATUALIZAR_ITEM_INCONSISTENCIA",
    RESETAR: "RESETAR"
};

const INITIAL = {
    etapa: 1,
    inventarioAberto: {
        ID: null,
        TerminalID: null,
        Descricao: "",
        Coletor: {
            ColetorID: null,
            ColetorNome: ""
        }
    },
    inventarioInconsistencia: {
        etiquetaCorrigida: ""
    },
    itemAtual: {
        Etiqueta: "",
        Local: undefined,
        Observacao: ""
    }
};

/**
 *
 * @param {*} state
 * @param {typeof Types_Inventario} action
 * @returns
 */
export default function inventarioReducer(state = INITIAL, action) {
    switch (action.type) {
        case Types_Inventario.ATUALIZAR_ETAPA:
            return {
                ...state,
                etapa: action.payload.etapa
            };
        case Types_Inventario.ATUALIZAR_ITEM_ATUAL:
            return {
                ...state,
                itemAtual: {
                    ...state.itemAtual,
                    ...action.payload
                }
            };
        case Types_Inventario.ATUALIZAR_ITEM_INCONSISTENCIA:
            return {
                ...state,
                inventarioInconsistencia: action.payload.etiquetaCorrigida
            };
        case Types_Inventario.ABRIR_INVENTARIO:
            return {
                ...state,
                inventarioAberto: action.payload.inventario,
                etapa: 2
            };
        case Types_Inventario.RESETAR:
            return INITIAL;
        default:
            return state;
    }
}

export const InventarioActions = {
    atualizarEtapa,
    abrirInventario,
    atualizarItemInconsistencia,
    atualizarEtiqueta,
    atualizarLocal,
    atualizarObservacao,
    resetItemAtual,
    resetarInventario,
    resetarEtapa,
    resetar
};

function atualizarEtapa(etapa) {
    return {
        type: Types_Inventario.ATUALIZAR_ETAPA,
        payload: { etapa }
    };
}

/**
 *
 * @param {Object} inventario
 * @param {number} inventario.ID
 * @param {number} inventario.TerminalID
 * @param {string} inventario.Descricao
 * @param {Object} inventario.Coletor
 * @param {number} inventario.Coletor.ColetorId
 * @param {string} inventario.Coletor.ColetorNome
 * @returns
 */
function abrirInventario(inventario) {
    return {
        type: Types_Inventario.ABRIR_INVENTARIO,
        payload: { inventario }
    };
}

/**
 *
 * @param {string} Etiqueta
 * @returns
 */
function atualizarEtiqueta(Etiqueta) {
    return {
        type: Types_Inventario.ATUALIZAR_ITEM_ATUAL,
        payload: { Etiqueta }
    };
}

/**
 * @typedef {import("../../../../Pages/Inventario/utils/fetchLocalidades").Localidade} LocalItem
 */
/**
 *
 * @param {LocalItem} [Local]
 * @returns
 */

function atualizarLocal(Local) {
    return {
        type: Types_Inventario.ATUALIZAR_ITEM_ATUAL,
        payload: { Local }
    };
}

/**
 *
 * @param {string} Observacao
 * @returns
 */
function atualizarObservacao(Observacao) {
    return {
        type: Types_Inventario.ATUALIZAR_ITEM_ATUAL,
        payload: { Observacao }
    };
}

function atualizarItemInconsistencia(etiquetaCorrigida) {
    return {
        type: Types_Inventario.ATUALIZAR_ITEM_INCONSISTENCIA,
        payload: { etiquetaCorrigida: etiquetaCorrigida }
    };
}

function resetItemAtual() {
    return {
        type: Types_Inventario.ATUALIZAR_ITEM_ATUAL,
        payload: INITIAL.itemAtual
    };
}

function resetarInventario() {
    return {
        type: Types_Inventario.ABRIR_INVENTARIO,
        payload: { inventario: INITIAL.inventarioAberto }
    };
}

function resetarEtapa() {
    return {
        type: Types_Inventario.ATUALIZAR_ETAPA,
        payload: { etapa: INITIAL.etapa }
    };
}

function resetar() {
    return {
        type: Types_Inventario.RESETAR
    };
}
